// React Components
import React, { Fragment } from 'react';

// Utilities & Helpers
import Helpers from '@Apis/helpers';
import { renderCharges, renderFreight, splitChargesData } from '../helpers';

// UI Components
import H3Text from '../../../../../../uilib/h3Text';

// Common Components
import ViewDocumentFooterDetails from '../../../../../Common/ViewDocFooterLeftSection';
import HideComponent from '../../../../../Common/RestrictedAccess/HideComponent';

const ViewGRNFooter = ({
  selectedGRN, user, MONEY, fileList, getAttachmentByIdLoading, updateAttachmentLoading, handleFileChange, priceMasking, isApInvoiceEnabled,
}) => {
  const { isDataMaskingPolicyEnable, isHideCostPrice, isHideSellingPrice } = priceMasking;

  const isVendorOverseas = (selectedGRN?.seller_info?.seller_type === 'OVERSEAS' || selectedGRN?.seller_type === 'OVERSEAS') && user?.tenant_info?.purchase_config?.sub_modules?.vendor?.settings?.hide_tax_for_overseas;

  return (
    <div className="view-document__totals-wrapper">
      <ViewDocumentFooterDetails
        remark={selectedGRN?.remark}
        narration={selectedGRN?.narration}
        fileList={fileList}
        disableAttachment={getAttachmentByIdLoading || updateAttachmentLoading}
        onFileChange={(value) => {
          handleFileChange(value);
        }}
        canUpdateAttachment={Helpers.getPermission(Helpers.permissionEntities.GOOD_RECEIVING, Helpers.permissionTypes.UPDATE, user)}
      />

      {['PURCHASE_ORDER', 'GOOD_RECEIVING_NOTE'].includes(selectedGRN?.grn_entity_type) && (isDataMaskingPolicyEnable && isHideCostPrice) ? (
        <HideComponent style={{
          width: '40%',
          marginLeft: 'auto',
          marginTop: '10px',
        }}
        />
      ) : (
        <div className={isApInvoiceEnabled ? 'display-none' : 'view-document__totals'}>
          <div className="view-document__totals-field">
            <H3Text text="Sub Total" className="view-document__totals-field-name" />
            <H3Text text={MONEY((selectedGRN?.grn_base_price), selectedGRN?.org_currency_info?.currency_code)} className="view-document__totals-field-value" />
          </div>
          {selectedGRN?.discount_amount !== 0 && (
            <div className="view-document__totals-field">
              <H3Text
                text={`Discount ${selectedGRN?.is_line_wise_discount
                  ? ''
                  : `(${selectedGRN?.is_discount_in_percent
                    ? `${selectedGRN?.discount_percentage}%`
                    : `${MONEY(selectedGRN?.discount_amount, selectedGRN?.org_currency_info?.currency_code)}`
                  })`
                  }`}
                className="view-document__totals-field-name"
              />
              {selectedGRN?.discount_amount > 0
                ? (
                  <H3Text
                    text={`(-) ${MONEY((selectedGRN?.discount_amount), selectedGRN?.org_currency_info?.currency_code)}`}
                    className="view-document__totals-field-value danger-text"
                  />
                )
                : (
                  <H3Text
                    text={MONEY((selectedGRN?.discount_amount), selectedGRN?.org_currency_info?.currency_code)}
                    className="view-document__totals-field-value"
                  />
                )}
            </div>
          )}
          {renderFreight({
            position: 'top',
            selectedGRN,
            MONEY,
            user,
          })}
          {renderCharges({
            charge: splitChargesData(selectedGRN?.other_charges).chargeWithTaxName,
            selectedGRN,
            user,
            MONEY,
          })}
          <div className="view-document__totals-field">
            <H3Text text="Taxable Amount" className="view-document__totals-field-name" />
            <H3Text text={MONEY((selectedGRN?.taxable_amount || 0), selectedGRN?.org_currency_info?.currency_code)} className="view-document__totals-field-value" />
          </div>
          {(selectedGRN?.tcs_id || selectedGRN?.tds_id) && !isVendorOverseas && (
            <div className="view-document__totals-field">
              <H3Text
                text={(
                  <Fragment>
                    {selectedGRN?.tcs_id ? 'TCS' : 'TDS'}
                    &nbsp;
                    <span className="table-subscript">{`${selectedGRN?.tcs_id ? 'tcs' : 'tds'}@${selectedGRN?.tcs_info?.tax_value || selectedGRN?.tds_info?.tax_value}%`}</span>
                  </Fragment>
                )}
                className="view-document__totals-field-name"
              />
              <H3Text text={selectedGRN?.tcs_id ? `${MONEY((selectedGRN?.tcs_info?.tcs_amount || 0), selectedGRN?.org_currency_info?.currency_code)}` : `(-)${MONEY((selectedGRN?.tds_info?.tds_amount || 0), selectedGRN?.org_currency_info?.currency_code)}`} className={selectedGRN?.tcs_id ? 'view-document__totals-field-value' : '  view-document__totals-field-value danger-text'} />
            </div>
          )}
          {renderFreight({
            position: 'bottom', selectedGRN, MONEY, user,
          })}
          {!isVendorOverseas && selectedGRN?.tax_info?.map((tax, i) => (
            <div key={i} className="view-document__totals-field">
              <H3Text text={tax?.tax_type_name} className="view-document__totals-field-nam" />
              <H3Text text={MONEY((tax?.tax_amount), selectedGRN?.org_currency_info?.currency_code)} className="view-document__totals-field-value danger-text" />
            </div>
          ))}
          {renderCharges({
            charge: splitChargesData(selectedGRN?.other_charges).chargeWithoutTaxName,
            selectedGRN,
            user,
            MONEY,
          })}
          {Math.abs(selectedGRN?.grn_round_off) !== 0 && (
            <div className="view-document__totals-field">
              <H3Text text="Round Off" className="view-document__totals-field-name" />
              {selectedGRN?.grn_round_off < 0
                ? (
                  <H3Text
                    text={`(-) ${MONEY((Math.abs(selectedGRN?.grn_round_off) || '0'), selectedGRN?.org_currency_info?.currency_code)}`}
                    className="view-document__totals-field-value danger-text"
                  />
                )
                : (
                  <H3Text
                    text={MONEY((selectedGRN?.grn_round_off || '0'), selectedGRN?.org_currency_info?.currency_code)}
                    className="view-document__totals-field-value"
                  />
                )}
            </div>
          )}
          <div className="view-document__totals-field view-document__totals-field-total">
            <H3Text text="Grand Total" className="view-document__totals-field-name" />
            <H3Text text={MONEY((selectedGRN?.grn_grand_total), selectedGRN?.org_currency_info?.currency_code)} className="view-document__totals-field-value" />
          </div>
          {selectedGRN?.total_payment_made ? (
            <div className="view-document__totals-field">
              <H3Text text="Payment Made" className="view-document__totals-field-name" />
              <H3Text text={`(-) ${MONEY((selectedGRN?.total_payment_made), selectedGRN?.org_currency_info?.currency_code)}`} className="view-document__totals-field-value danger-text" />
            </div>
          ) : <Fragment />}
          {Helpers.getValueTotalInObject(selectedGRN?.debit_note_info, 'db_total') > 0 && (
            <div className="view-document__totals-field">
              <H3Text text="Credit Applied" className="view-document__totals-field-name" />
              <H3Text
                text={`(-) ${MONEY(
                  Helpers.getValueTotalInObject(selectedGRN?.debit_note_info, 'document_db_total')
                  || Helpers.getValueTotalInObject(selectedGRN?.debit_note_info, 'db_total')
                  || 0,
                  selectedGRN?.org_currency_info?.currency_code,
                )}`}
                className="view-document__totals-field-value danger-text"
              />
            </div>
          )}
          <div className="view-document__totals-field view-document__totals-field-total">
            <H3Text text="Total Due" className="view-document__totals-field-name" />
            <H3Text text={MONEY((selectedGRN?.grn_grand_total - (Helpers.getValueTotalInObject(selectedGRN?.debit_note_info, 'document_db_total') || Helpers.getValueTotalInObject(selectedGRN?.debit_note_info, 'db_total')) - selectedGRN?.total_payment_made), selectedGRN?.org_currency_info?.currency_code)} className="view-document__totals-field-value" />
          </div>
        </div>
      )}
    </div>
  );
};

export default ViewGRNFooter;
